module.exports = __webpack_public_path__ + "img/icon_pczx_tw.00d1ce79.svg";